import CurrencyLogo from 'components/CurrencyLogo'
import { useApiTokenValue } from 'hooks/useTokenPrice'
import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { ThemedText } from 'theme'
import { formatDollarAmount } from 'utils/formatDollarAmt'

import { EarnedItemType } from '../../context/RewardContext'
import { CurrencyFlexBetween, FlexRowCenter } from '../../styleds'

interface EarnedTokenRowProps {
  item: EarnedItemType
}

const EarnedTokenRow: React.FC<EarnedTokenRowProps> = ({ item }) => {
  const theme = useContext(ThemeContext)
  const { value: fiatValue } = useApiTokenValue(item.amount)

  return (
    <CurrencyFlexBetween>
      <FlexRowCenter>
        <CurrencyLogo currency={item.token} size="20px" />
        <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" lineHeight="20px" color={theme.textPrimary}>
          {item.token?.symbol}
        </ThemedText.DeprecatedBody>
      </FlexRowCenter>

      <FlexRowCenter>
        <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" lineHeight="20px" color={theme.textPrimary}>
          {item.amount?.toSignificant(6)}
        </ThemedText.DeprecatedBody>
        <ThemedText.DeprecatedBody fontSize="14px" fontWeight="500" lineHeight="20px" color={theme.buttonPrimary}>
          {formatDollarAmount(fiatValue)}
        </ThemedText.DeprecatedBody>
      </FlexRowCenter>
    </CurrencyFlexBetween>
  )
}

export default EarnedTokenRow
